export default {"src":"/_next/static/image/public/images/flags/flag_1671.eb6f8cfd24390ccdfcb15cb0afc66b70.svg","height":16,"width":24};